/** 261104 E1-P1 — nút vào «Chuyển thể mới» đặt trên đầu tab Chuyển thể (luồng cũ nằm ngay bên dưới, giữ nguyên). */
import React from 'react';
import { useNavigate } from 'react-router-dom';

const SkillAdaptEntry: React.FC<{ storyId: string }> = ({ storyId }) => {
  const navigate = useNavigate();
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 10, margin: '0 0 10px', flexWrap: 'wrap' }}>
      <span style={{ color: '#7A818A', fontSize: 12.5 }}>Luồng chuyển thể theo phương pháp của đội content (bốn quyết định)</span>
      <button type="button" onClick={() => navigate(`/source-stories/${storyId}/skill-adaptation`)}
        style={{ minHeight: 34, padding: '6px 14px', border: '1px solid #2F5FA8', background: '#2F5FA8', color: '#fff', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}>Chuyển thể mới</button>
    </div>
  );
};

export default SkillAdaptEntry;
